// dependencies
import { Map, isImmutable } from "immutable";
import { useState } from "react";

/** Manages the state of an employee list on the <EasyAddForm />
 * component. Will keep track of the list of employees as well as the
 * employee picker value.
 */
const useEmployeeList = (defaultEmployees = []) => {
	const [employees, setEmployees] = useState(defaultEmployees);
	const [employeePickerValue, setEmployeePicker] = useState(null);

	/**
	 * Remove an employee by removeIndex.
	 * @param {number} removeIndex - index of the employee we are removing
	 */
	const removeEmployee = (removeIndex) => {
		const filteredEmployees = employees.filter((_, employeeIndex) => {
			return employeeIndex !== removeIndex;
		});
		setEmployees(filteredEmployees);
	};

	/**
	 * Handle changing the employee picker value. Will add the employee to the
	 * list if a Map or will update the input value if a string.
	 */
	const handleEmployeesChange = (value) => {
		if (isImmutable(value)) {
			setEmployees(employees.push(Map({ id: value.get("id"), name: value.get("name") })));
			setEmployeePicker("");
		} else {
			setEmployeePicker(value);
		}
	};

	/**
	 * Set employee list.
	 */
	const setEmployeeList = (employeesList) => {
		setEmployees(employeesList);
	};

	/**
	 * Resets the hook state.
	 */
	const resetState = () => {
		setEmployeePicker(null);
		setEmployees(defaultEmployees);
	};

	return [employees, employeePickerValue, handleEmployeesChange, removeEmployee, setEmployeeList, resetState];
};

export default useEmployeeList;
